import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type DeleteDepartmentResponse = {
  success: boolean;
  message: string;
  data?: { _id?: string } | null;
};

const deleteDepartment = async (
  id: string
): Promise<DeleteDepartmentResponse> => {
  const { data } = await customAxios.delete<DeleteDepartmentResponse>(
    `/departments/${id}`
  );
  return data;
};

export const useDeleteDepartment = () => {
  const queryClient = useQueryClient();

  return useMutation<DeleteDepartmentResponse, AxiosError, string>({
    mutationFn: deleteDepartment,
    onSuccess: async (data, id) => {
      showNotification({
        title: "Deleted",
        message: data.message ?? "Department deleted successfully",
        color: "green",
      });

      await queryClient.invalidateQueries(["departments"]);
      await queryClient.invalidateQueries(["department", id]);
    },
    onError: (error) =>
      showNotification({
        title: "Error deleting department",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to delete department",
        color: "red",
      }),
  });
};
